import React from "react";

import FormInputWidget from "./FormInputWidget";

const FormPasswordWidget = props => (
  <FormInputWidget {...props} type="password" />
);

export default FormPasswordWidget;



// WEBPACK FOOTER //
// ./components/form/widgets/FormPasswordWidget.jsx